import { PlatformEnum } from 'src/shared/enums/platform.enum';
import { UserStatusEnum } from 'src/shared/enums/user.enum';
import {
  CenterRolesEnum,
  UserCenterRequestEnum,
} from 'src/shared/enums/usersCenter.enum';
import { IUser } from 'src/shared/models';
import { isConPlatform, getConUserStatus } from 'utils';
import { config } from 'config/config';

const { PLATFORM } = config.APP;

const {
  ACCEPTED_EMPLOYEE,
  ACCEPTED_MANAGER,
  DENIED,
  HCP_NOT_VALIDATED,
  MANAGER_NOT_VALIDATED,
  NO_CENTER,
  STAFF_NOT_VALIDATED,
} = UserStatusEnum;
const {
  DECLINED: REQUEST_DECLINED,
  PENDING: REQUEST_PENDING,
  ACCEPTED: REQUEST_ACCEPTED,
} = UserCenterRequestEnum;

export const conNoAutoValidatePlatforms: PlatformEnum[] = [
  PlatformEnum.CON_DEUTSCHLAND,
];

export const AUTO_VALIDATE = !conNoAutoValidatePlatforms.includes(
  PLATFORM as PlatformEnum,
);

export const getUserStatus = (user: IUser): UserStatusEnum => {
  if (isConPlatform) return getConUserStatus(user);
  return getPinUserStatus(user);
};

const getPinUserStatus = (user: IUser) => {
  const { usersCenter } = user;

  const center = usersCenter?.filter((request) => request.status);

  if (!center?.length) return NO_CENTER;

  const { userRequest, idRole } = center[0];

  switch (true) {
    case userRequest === REQUEST_ACCEPTED:
      return idRole === CenterRolesEnum.MANAGER
        ? ACCEPTED_MANAGER
        : ACCEPTED_EMPLOYEE;

    case userRequest === REQUEST_DECLINED:
      return DENIED;

    case userRequest === REQUEST_PENDING:
      if (idRole === CenterRolesEnum.MANAGER) return MANAGER_NOT_VALIDATED;
      return !user.idSpecialty?.isHCP ? STAFF_NOT_VALIDATED : HCP_NOT_VALIDATED;

    default:
      return DENIED;
  }
};
